module.exports = __webpack_public_path__ + "img/accessory_hat_03.b00c269c.svg";